import { datadogRum } from '@datadog/browser-rum'
import { LegendDataResponse, updateMapStateProperty } from '@app/redux/riskMap/riskMapSlice'
import { useFetchLayer } from '@app/domains/layers/hooks/useFetchLayer'
import { useFetchLegends } from '@app/hooks/useFetchLegends'
import { useFetchSettings } from '@app/hooks/useFetchSettings'
import { useShowToastOnClientChange } from '@app/hooks/useShowToastOnClientChange'
import { userAtom } from '@app/hooks/useUserProfile'
import { useFetchLayerStyles, useFetchPreferences } from '@app/services/legendService'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useDispatch } from 'react-redux'
import { getCurrentSubdomain } from '@app/utils/getCurrentSubdomain'

const AppLoaderRefactored = () => {
  const clientName = getCurrentSubdomain(
    window.location.hostname,
    import.meta.env.VITE_SAFE_DOMAIN ?? 'rex.local',
  )
  const dispatch = useDispatch()
  const { data: legends } = useFetchLegends(clientName ?? '')
  useFetchLayer()
  useFetchSettings(clientName ?? '')
  useFetchPreferences()
  useFetchLayerStyles()
  useShowToastOnClientChange()

  const userQuery = useAtomValue(userAtom)
  const userProfile = userQuery.data

  useEffect(() => {
    if (legends) {
      dispatch(updateMapStateProperty({ legendsData: legends as LegendDataResponse }))
    }
  }, [dispatch, legends])

  useEffect(() => {
    if (!userProfile?.email) {
      Sentry.setUser(null)
      datadogRum.setUser({})
      return
    }

    Sentry.setUser({ email: userProfile.email })
    datadogRum.setUser({
      id: userProfile.user_uuid,
      email: userProfile.email,
      role: userProfile.user_roles?.join(',') || '',
      client: userProfile.client_name,
    })
  }, [userProfile])

  return null
}

export default AppLoaderRefactored
